return;
(function () {
  // CUSTOMISABLE SETTINGS
  const promoImage = "https://cdn.shopify.com/s/files/1/0671/7476/0722/files/83ec7b30-648b-4ba9-87dc-51652e824c46.jpg?v=1753796309";
  const promoHeading = "20% off all Dunlop Picks";
  const promoText = "New range just added. Discount applied automatically at checkout.";
  const promoLink = "/collections/picks-plectrums";
  const promoButtonText = "SHOP NOW";

  document.addEventListener("DOMContentLoaded", function () {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        const tagMatch = cart.items.some((item) =>
          item.product_title.toLowerCase().includes("plectrum") ||
          item.product_title.toLowerCase().includes("pick")
        );

        if (!tagMatch) {
          const promoHTML = `
            <div id="cart-promo" class="cart-promo-container">
              <div class="cart-promo-inner">
                <img src="${promoImage}" alt="Promo" width="100" height="100" />
                <div class="cart-promo-text">
                  <h3>${promoHeading}</h3>
                  <p>${promoText}</p>
                  <a href="${promoLink}" class="cart-promo-btn">${promoButtonText}</a>
                </div>
              </div>
            </div>
          `;

          const cartForm = document.querySelector("form[action='/cart']");
          if (cartForm) {
            const promoDiv = document.createElement("div");
            promoDiv.innerHTML = promoHTML;
            cartForm.parentNode.insertBefore(promoDiv, cartForm);
          }
        }
      });
  });
})();